import httpRequest from '@/utils/request';
import Axios from 'axios';
const CancelToken = Axios.CancelToken;

export default class RequestApi {
  public baseUrl = '';
  public cancel: any;
  constructor(moduleName: string) {
    this.baseUrl = '/' + moduleName;
  }
  public createUrlById(id: string) {
    return `${this.baseUrl}/${id}`;
  }
  public createStatusUrlById(id: string) {
    return `${this.createUrlById(id)}/status`;
  }
  public createUrl(route: string[]) {
    return `${this.baseUrl}/` + route.join('/');
  }
  public getData<Q, R = IResponseData.IBaseData>(url: string, params?: Q): Promise<R> {
    return httpRequest.get(url, {
      params,
    });
  }
  public getDataByCancel<Q, R = IResponseData.IBaseData>(url: string, params: Q): Promise<R> {
    if (this.cancel) {
      this.cancel('CANCEL');
    }
    return httpRequest.get(url, {
      params,
      cancelToken: new CancelToken((c) => {
        this.cancel = c;
      }),
    });
  }
  public deleteData<R = IResponseData.IBaseData>(url: string): Promise<R> {
    return httpRequest.delete(url);
  }
  public putData<Q, D, R = IResponseData.IBaseData>(
    url: string,
    data: D,
    params: Q,
  ): Promise<R> {
    return httpRequest.put(url, data, {
      params,
    });
  }
  public postData<Q, D, R = IResponseData.IBaseData>(
    url: string,
    data: D,
    params?: Q,
  ): Promise<R> {
    return httpRequest.post(url, data, {
      params,
    });
  }
}
